import React, { useState } from "react";
// react component for creating dynamic tables
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import ReactBSAlert from "react-bootstrap-sweetalert";
import { useAsyncEffect } from "use-async-effect";
import { useHistory } from "react-router-dom";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import formsComponentStyles from "assets/theme/components/forms.js";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import GetApp from "@material-ui/icons/GetApp";
import AddIcon from "@material-ui/icons/Add";
import IconButton from "@material-ui/core/IconButton";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
// @material-ui/lab components
// @material-ui/icons components
// core components
import Snackbar from "components/Snackbar/Snackbar.js";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import btnComponentStyles from "assets/theme/components/button.js";
import LoadingAnimation from "components/Animations/loading";
import Slide from "@material-ui/core/Slide";
import {
  redirectToLogout
} from "common/SharedFn";
import {
  getAllDiscountType,
  addDiscountType,
  editDiscountType,
  deleteDiscountType
} from "../../network/ApiAxios";
import { Edit, Delete, ArrowBack } from "@material-ui/icons";
import "react-datepicker/dist/react-datepicker.css";

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(btnComponentStyles);
const useStylesForms = makeStyles(formsComponentStyles);

const createHistory = require("history").createBrowserHistory;

const pagination = paginationFactory({
  page: 1,
  alwaysShowAllBtns: true,
  showTotal: true,
  withFirstAndLast: false,
  sizePerPage: 50,
  sizePerPageRenderer: ({ onSizePerPageChange }) => (
    <div className="dataTables_length" id="datatable-basic_length">
      <label>
        Show{" "}
        {
          <select
            name="datatable-basic_length"
            aria-controls="datatable-basic"
            className="form-control form-control-sm"
            onChange={(e) => onSizePerPageChange(e.target.value)}
          >
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="1000">1000</option>
          </select>
        }{" "}
        entries.
      </label>
    </div>
  ),
});

const { SearchBar } = Search;

const { ExportCSVButton } = CSVExport;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const DiscountTable = (props) => {
    const classes = {
        ...useStyles(),
        ...useStylesButtons(),
        ...useStylesForms(),
    };
    const [alert, setAlert] = React.useState(false);
    const componentRef = React.useRef(null);
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState("");
    const [notifMessage, setNotifMessage] = useState("");
    const [showError, setShowError] = React.useState(false);
    const [success, setSuccess] = React.useState(false);
    const [addModal, setAddModal] = useState(false);
    const [id, setId] = useState();
    const [name, setName] = useState("");
    const [executeUpdate, setExecuteUpdate] = useState(false);
    const [executeDelete, setExecuteDelete] = useState(false);
    const [forceRefresh, setForceRefresh] = useState(false);
    let history = useHistory();

    const warningAlert = (title, message, action) => {
        setAlert(
          <ReactBSAlert
            warning
            style={{ display: "block", marginTop: "-100px" }}
            title={title}
            onConfirm={action}
            onCancel={() => setAlert(null)}
            showCancel="true"
            cancelBtnBsStyle="warning"
            cancelBtnText="No"
            confirmBtnBsStyle="success"
            confirmBtnText="Yes"
            btnSize=""
            confirmBtnStyle={{
              marginRight: undefined,
              borderColor: undefined,
              boxShadow: undefined,
            }}
            cancelBtnStyle={{
              marginRight: undefined,
              borderColor: undefined,
              boxShadow: undefined,
            }}
          >
            {message}
          </ReactBSAlert>
        );
    };

    const showSuccessNotification = (message) => {
        setNotifMessage(message);
        setSuccess(true);
        setTimeout(function () {
          setSuccess(false);
        }, 3000);
    };
    
    const showErrorNotification = (message) => {
        setNotifMessage(message);
        setShowError(true);
        setTimeout(function () {
          setShowError(false);
        }, 3000);
    };

    const setCurrentRecord = (info) => {
        const {id, name} = info;
        setName(name);
        setId(id);
    }

    const clearCurrentRecord = () => {
        setName("");
        setId();
    }

    // fetch all discount types
    const fetchDiscountTypes = async () => {
        setForceRefresh(false);
        setIsLoading(true);
        try {
          const response = await getAllDiscountType();
          const { data } = response;
          if (data.result.isSuccess) {
            setData(data.data.map((prop) => makeTableRow(prop)));
          } else {
            showErrorNotification(data.result.description);
            if (data.result.code == -2) {
              redirectToLogout();
            }
          }
        } catch (ex) {
          showErrorNotification("Failed to fetch Discounts");
        }
        setIsLoading(false);
    };

    // add discount type
    const addDiscount = async () => {
        setIsLoading(true);
        try{
        const response = await addDiscountType(name);
        const { data } = response;
        if (data.result.isSuccess) {
          showSuccessNotification("Discount Type Added Successfully");
          setAddModal(false);
          setForceRefresh(true);
        } else {
          showErrorNotification(data.result.description);
          setIsLoading(false);
        }
        }
        catch(ex){
          showErrorNotification("Failed to add discount type");
          setIsLoading(false);
        }
    };

    // update discount type
    const updateDiscount = async () => {
        setExecuteUpdate(false);
        setIsLoading(true);
        try{
            const response = await editDiscountType(id,name);
            const { data } = response;
            if (data.result.isSuccess) {
                showSuccessNotification("Discount Type Updated Successfully");
                setAddModal(false);
                setForceRefresh(true);      
            } else {
                showErrorNotification(data.result.description);
                setIsLoading(false);
            }
        } catch(ex){
          showErrorNotification("Failed to update discount type");
          setIsLoading(false);
        }
    };

    // delete a discount type
    const deleteDiscount = async () => {
        setExecuteDelete(false);
        setIsLoading(true);
        try{
            const response = await deleteDiscountType(id);
            const { data } = response;
            if (data.result.isSuccess) {
                showSuccessNotification("Discount Type Deleted Successfully");
                setAddModal(false);
                setForceRefresh(true);      
            } else {
                showErrorNotification(data.result.description);
                setIsLoading(false);
            }
        } catch(ex){
            showErrorNotification("Failed to delete discount type");
            setIsLoading(false);
        }
    };

    useAsyncEffect(async () => {
        if (executeUpdate) {
            updateDiscount();
        } else if(executeDelete){
            deleteDiscount();
        } else{
            fetchDiscountTypes();
        }
    }, [executeUpdate, executeDelete, forceRefresh]);

    const makeTableRow = (info) => {
        return {
            ...info,
            actions: (
                <div className="actions-right">
                    <Tooltip title="Edit">
                        <Button size="small" 
                            classes={{
                                root: classes.buttonContainedWarning,
                            }} 
                            variant="contained" 
                            style={{ marginLeft: "5px" }}
                            onClick={() => {
                            setCurrentRecord(info);
                            setAddModal(true);
                        }}>
                        <Box component={Edit} />
                        </Button>
                    </Tooltip>
                    <div style={{ display: "inline-block" }}>
                        <Tooltip title="Delete">
                            <Button
                                size="small"
                                classes={{
                                    root: classes.buttonContainedError,
                                }}
                                variant="contained"
                                style={{ marginLeft: "5px" }}
                                onClick={() => {warningAlert("Delete Discount Type","Are you sure you would like to delete this discount type  "+info.name+"?",async () =>  {
                                    setCurrentRecord(info);
                                    setAlert(null);
                                    setExecuteDelete(true);
                                })}}
                            >
                                <Box component={Delete} />
                            </Button>
                        </Tooltip>
                    </div>
                </div>
            ),
        };
    };

    return (
        <>
            {alert}
            {/* Page content */}
            <Container
                maxWidth={false}
                component={Box}
                marginTop="-4.5rem"
                classes={{ root: classes.containerRoot }}
            >
                <Grid container>
                    <Grid item xs={12}>
                        <Card elevation={0}>
                        <div style={{width: "100%"}}>
                            <ToolkitProvider
                                data={data}
                                keyField="id"
                                columns={[
                                    {
                                        dataField: "id",
                                        text: "ID",
                                        sort: true,
                                        style: {'whiteSpace': 'normal'}
                                    },
                                    {
                                        dataField: "name",
                                        text: "Name",
                                        sort: true,
                                        style: {'whiteSpace': 'normal'}
                                    },
                                    {
                                        dataField: "actions",
                                        classes: "actions-col",
                                        headerClasses: "actions-col",
                                        text: "Actions",
                                        csvExport: false,
                                    },
                                ]}
                                search
                                exportCSV
                            >
                                {
                                    (props) => (
                                        <>
                                        <CardHeader
                                          style={{ paddingTop: "0.875rem", paddingBottom: "0.875rem" }}
                                          title={
                                            <Box display="flex" alignItems="center" style={{ gap: 12 }}>
                                              <Tooltip title="Back">
                                                <Button
                                                  size="small"
                                                  classes={{ root: classes.buttonContainedPrimary }}
                                                  variant="contained"
                                                  onClick={() => { history.goBack(); }}
                                                >
                                                  <Box component={ArrowBack} />
                                                </Button>
                                              </Tooltip>
                                              <Box
                                                component={Typography}
                                                variant="h2"
                                                marginBottom="0!important"
                                              >
                                                <Box component="span">Discount Types</Box>
                                              </Box>
                                              <Tooltip title="Add new Discount Type">
                                                <IconButton
                                                  size="small"
                                                  onClick={() => {
                                                    clearCurrentRecord();
                                                    setAddModal(true);
                                                  }}
                                                  style={{
                                                    width: 32, height: 32,
                                                    backgroundColor: "#fff",
                                                    border: "1px solid #5e72e4",
                                                    color: "#5e72e4",
                                                  }}
                                                >
                                                  <AddIcon style={{ width: 18, height: 18 }} />
                                                </IconButton>
                                              </Tooltip>
                                            </Box>
                                          }
                                          action={
                                            <Box
                                              display="flex" alignItems="center" flexWrap="wrap"
                                              justifyContent="flex-end"
                                              style={{ gap: 8, marginTop: 8, marginRight: 8 }}
                                            >
                                              <div
                                                id="datatable-basic_filter"
                                                style={{ display: "flex", alignItems: "center", height: 40 }}
                                              >
                                                <SearchBar
                                                  className="form-control-sm"
                                                  placeholder="Search..."
                                                  style={{ height: 40, margin: 0, boxSizing: "border-box" }}
                                                  {...props.searchProps}
                                                />
                                              </div>
                                              <Tooltip title="Download CSV">
                                                <span style={{ display: "flex" }}>
                                                  <ExportCSVButton
                                                    className="MuiButtonBase-root"
                                                    style={{
                                                      width: 40, height: 40, padding: 0,
                                                      display: "flex", alignItems: "center", justifyContent: "center",
                                                      border: "1px solid #172b4d", borderRadius: 8,
                                                      color: "#fff", backgroundColor: "#172b4d", cursor: "pointer",
                                                    }}
                                                    {...props.csvProps}
                                                  >
                                                    <GetApp style={{ width: 18, height: 18 }} />
                                                  </ExportCSVButton>
                                                </span>
                                              </Tooltip>
                                            </Box>
                                          }
                                        />
                                        <div className="table-responsive">
                                            <BootstrapTable
                                                ref={componentRef}
                                                {...props.baseProps}
                                                bootstrap4={true}
                                                pagination={pagination}
                                                bordered={true}
                                                striped={true}
                                                //filter={ filterFactory() }
                                                noDataIndication={() =>
                                                    isLoading ? (
                                                    <Box
                                                        component={Grid}
                                                        container
                                                        justifyContent="center"
                                                        className="justify-content-center"
                                                    >
                                                        <div
                                                        className="text-center"
                                                        style={{ width: "20%" }}
                                                        >
                                                        <LoadingAnimation />{" "}
                                                        </div>
                                                    </Box>
                                                    ) : (
                                                    <h4>No Records</h4>
                                                    )
                                                }
                                                id="main-table"
                                            />
                                        </div>
                                        </>
                                    )
                                }
                            </ToolkitProvider>
                        </div>
                        </Card>
                    </Grid>
                </Grid>
                <Dialog
                    classes={{
                        root: classes.center + " " + classes.modalRoot,
                        paper: classes.modal + " " + classes.modalSmall,
                      }}
                    open={addModal && !isLoading}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={() => setAddModal(false)}
                >
                    <DialogTitle
                        disableTypography
                        className={classes.modalHeader}
                    >
                        <h4 className={classes.modalTitle}>
                            {id == null || id === "" ? "Add" : "Edit"} Discount Type
                        </h4>
                    </DialogTitle>
                    <DialogContent
                        className={classes.modalBody + " " + classes.modalSmallBody}
                    >
                        <form>
                            <FormGroup>
                                <FormLabel>Name</FormLabel>
                                <OutlinedInput
                                    fullWidth
                                    type="text"
                                    placeholder="Name"
                                    value={name ?? ""}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </FormGroup>
                        </form>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => setAddModal(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={() =>
                                id == null || id === "" ? addDiscount() : updateDiscount()
                            }  
                            classes={{
                                root: classes.buttonContainedPurple100,
                            }}
                            variant="contained"
                        >
                            {id == null || id === "" ? "Add" : "Update"}
                        </Button>
                    </DialogActions>
                </Dialog>
                <Snackbar
                    place="tr"
                    color="success"
                    // icon={AddAlert}
                    message={notifMessage}
                    open={success}
                    closeNotification={() => setSuccess(false)}
                    close
                />

                <Snackbar
                    place="tr"
                    color="rose"
                    // icon={AddAlert}
                    message={notifMessage}
                    open={showError}
                    closeNotification={() => setShowError(false)}
                    close
                />
            </Container>
        </>
    );
};

export default DiscountTable;